module.exports = __webpack_public_path__ + "static/media/up.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/up.png
// module id = 884
// module chunks = 0